<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Мероприятия</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down">
              </v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :search="search" :items="exhibitionData"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="id"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="complex.selected">
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.dateFrom }}</td>
                  <td>{{ props.item.dateTo }}</td>
                  <td>{{ cityMap.get(props.item.cityId) ? cityMap.get(props.item.cityId) : '--' }}</td>
                  <td>
                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID мероприятия</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ID мероприятия" v-model="modalData.id" readonly></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Наименование</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Наименование" v-model="modalData.name" :rules="rules.required"
                              required></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Дата проведения</v-subheader>
                          </v-flex>
                          <v-flex xs8>

                            <v-text-field @click="periodData.modalOpen = true"
                              :value="periodData.value.start + ' — ' + periodData.value.end" :label="periodData.name"
                              append-icon="close" @click:append="clearPeriod()" readonly
                              :rules="rules.period"></v-text-field>

                            <template>
                              <v-dialog v-model="periodData.modalOpen" full-width width="290px">
                                <v-date-picker v-model="period" color="primary" :first-day-of-week="1" multiple
                                  locale="ru-ru">
                                  <v-spacer></v-spacer>
                                  <v-btn color="primary" flat @click="periodData.modalOpen = false">Ok</v-btn>
                                  <v-btn color="red darken-1" flat @click="clearPeriod()">Сбросить</v-btn>
                                  <v-spacer></v-spacer>
                                </v-date-picker>
                              </v-dialog>
                            </template>

                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Тип данных</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-select label="Город" v-model="modalData.cityId" :items="cityListForSelect"
                              :rules="rules.required"></v-select>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить мероприятие?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Moment from "moment";
import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

export default {
  components: {
    Moment
  },

  data() {
    return {
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      readonlyFields: true,
      openColorBox: false,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
        period: [v => v !== " — " || "Нужно выбрать период"]
      },
      search: '',
      periodData: {
        name: "Период мероприятия",
        value: {
          start: '',
          end: ''
        },
        icon: "date_range",
        modalOpen: false
      },
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false,
      },
      complex: {
        selected: [],
        headers: [
          {
            text: 'ID',
            value: 'id'
          },
          {
            text: 'Наименование',
            value: 'name'
          },
          {
            text: 'Дата начала',
            value: 'dateFrom'
          },
          {
            text: 'Дата окончания',
            value: 'dateTo'
          },
          {
            text: "Город",
            value: "cityId"
          },
          {
            text: 'Действия',
            value: ''
          }
        ],
      }
    };
  },

  mounted: function () {
    /**
     * Загружаем данные по мероприятиям при первой отрисовке страницы
     * Если exhibitionData не пустой, то не обновляемся
     */
    if (this.exhibitionData.length === 0) {
      this.refresh();
    }

    /**
     * Если список городов пуст, то загружаем и его тоже
     */
    if (this.$store.getters["cities/items"].length === 0) {
      this.$store.dispatch('cities/loadItems');
    }
  },

  computed: {
    /**
     * Данные по мероприятиям
     * @returns {default.computed.exhibitionData|(function())|Array|getters.exhibitionData}
     */
    exhibitionData() {
      return this.$store.getters['exhibition/exhibitionData'];
    },

    /**
     * Список городов для Select'a
     * @returns {default.computed.cityListForSelect|(function())|Array|getters.cityData}
     */
    cityListForSelect() {
      return this.$store.getters['cities/items'].map(c => {
        return {
          text: c.name,
          value: c.id
        }
      })
    },

    /**
     * Объект Map, содержащий пары "cityId-cityName"
     * @returns {default.computed.cityMap|(function())|Array|getters.cityData}
     */
    cityMap() {
      let result = new Map();

      this.$store.getters['cities/items'].forEach(c => {
        result.set(c.id, c.name);
      })

      return result;
    },

    /**
     * Период проведения мероприятия
     */
    period: {
      get: function () {
        let dateRange = [];

        if (this.periodData.value.start !== "" && this.periodData.value.end !== "") {
          let range = moment.range(this.periodData.value.start, this.periodData.value.end);

          for (let day of range.by("day")) {
            dateRange.push(day.format("YYYY-MM-DD"));
          }
        }

        return dateRange;
      },

      set: function (selectedDateList) {
        let dateRange = [];

        if (this.periodData.value.start !== "" && this.periodData.value.end !== "" && selectedDateList.length !== 0) {
          let lastSelectedDate = _.last(selectedDateList);

          if (moment(lastSelectedDate) < moment(this.periodData.value.start)) {
            this.modalData.dateFrom = this.periodData.value.start = lastSelectedDate;
          } else if (moment(lastSelectedDate) > moment(this.periodData.value.end)) {
            this.modalData.dateTo = this.periodData.value.end = lastSelectedDate;
          }

          let range = moment.range(this.periodData.value.start, this.periodData.value.end);

          for (let day of range.by("day")) {
            dateRange.push(day.format("YYYY-MM-DD"));
          }
        } else if (selectedDateList.length !== 0) {
          this.modalData.dateFrom = this.modalData.dateTo = this.periodData.value.start = this.periodData.value.end = _.last(selectedDateList);
        } else {
          this.modalData.dateFrom = this.modalData.dateTo = this.periodData.value.start = this.periodData.value.end = '';
        }

        return dateRange;
      }
    }
  },

  methods: {
    /**
     * Обновление данных по мероприятиям
     */
    refresh() {
      this.$store._actions['exhibition/getExhibitionData'][0]();
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      // Если редактирование
      if (item !== null && typeof item !== 'undefined') {
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.periodData.value = {
          start: item.dateFrom,
          end: item.dateTo
        };
        this.editedIndex = this.exhibitionData.indexOf(item);
        this.readonlyFields = true;
        // Если добавление
      } else {
        this.periodData.value = {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        };
        this.modalData = {
          id: -1,
          name: '',
          dateFrom: this.periodData.value.start,
          dateTo: this.periodData.value.end,
          cityId: null
        };
        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }

      this.popupEdit.isOpen = true;
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(this.exhibitionData[this.editedIndex], this.oldModalData);
      }

      this.clearPeriod();
      this.popupEdit.isOpen = false;
    },

    /**
     * Сохранение отредактированного элемента
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.$store._actions['exhibition/saveExhibitionData'][0]({ index: this.editedIndex, data: this.modalData }).then(() => {
          this.clearPeriod();
          this.popupEdit.isOpen = false;
        })
      }
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    removeItemConfirm(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
    },

    /**
     * Удаление элемента
     * @param item
     */
    actionRemove(item) {
      this.$store._actions['exhibition/removeExhibitionData'][0]({ item: item });
      this.popupRemove.isOpen = false;
    },

    /**
     * Сброс периода
     */
    clearPeriod() {
      this.periodData.value.start = "";
      this.periodData.value.end = "";
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ui/Exhibition.vue